import { BetType } from "./Enums"
import React from "react"
import '../../scss/play-area-desktop-buttons.scss'

import gsap from "gsap";
import {Quad} from 'gsap'

import { getBellowIcon , getAboveIcon } from "../../utils/constants";

import App from "../../App";

interface PlayAreaDesktopButtonProps{
    type : BetType;
    openContest:any
    scssClass:string

    makeBet:(type : BetType)=>void;
}

export class PlayAreaDesktopButton extends React.Component<PlayAreaDesktopButtonProps>{

    private button = React.createRef<HTMLDivElement>();

    /**
     * move
     */
    public move(x : number  , opacity:number ,  duration : number ) {
        gsap.to(this.button.current , {opacity , duration , x:x , ease:Quad.easeOut});
    }

    render =()=>{
        const background = this.props.type === BetType.closeAbove ? this.getAbove() : this.getBellow();
        const icon = this.props.type === BetType.closeAbove ? getAboveIcon(App.getPropertyFromStyle('--buttons-font-color')) : getBellowIcon(App.getPropertyFromStyle('--buttons-font-color'));
        const labe = this.props.type === BetType.closeAbove ? 'above' : 'below';
        const Odds = this.props.type === BetType.closeAbove ? this.props.openContest?.moonOdds || 0 : this.props.openContest?.rektOdds || 0;
        return(
            <div ref={this.button} className={this.props.scssClass} onClick={()=>{this.props.makeBet(this.props.type)}}>
                <div className="bt-game-desktop-content">
                    {icon}
                    <h2>{`Close ${labe}`}</h2>
                    <p>{`${Odds.toFixed(2) || 0} Odds`}</p>
                </div>
                {background}
            </div>
        )
    }


    getBellow = ()=>{
        return <svg className="bt-game-desktop-background"  viewBox="0 0 577 284" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M496.993 284H40.8405C18.7491 284 0.840515 266.091 0.840515 244V40C0.840515 17.9086 18.7491 -3.05176e-05 40.8405 -3.05176e-05H576.984L496.993 284Z" fill={App.getPropertyFromStyle('--secondary-color')}/>
        </svg>
        
    }

    getAbove = ()=>{
        return <svg className="bt-game-desktop-background"  viewBox="0 0 578 284" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M80.2197 0L537.372 0C559.464 0 577.372 17.9086 577.372 40V244C577.372 266.091 559.464 284 537.372 284L0.228516 284L80.2197 0Z" fill={App.getPropertyFromStyle('--primary-color')}/>
        </svg>        
    }

   
}